import { writable } from "svelte/store";

let OrderMessagesStore;
export default OrderMessagesStore = writable([]);
